<div class="modal-header bg-light border-bottom">
  <div>
    <h5 class="modal-title mb-1">{{language.unansweredQuestions}}</h5>
    <small class="text-muted">{{language.pleaseAnswerAllQuestionsBeforeSubmitting}}</small>
  </div>
  <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
</div>

<div class="modal-body" style="max-height: 450px; overflow-y: auto;">
  
  <!-- Alert Banner -->
  <div class="alert alert-warning d-flex align-items-center mb-3" role="alert">
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-exclamation-triangle-fill me-2 flex-shrink-0" viewBox="0 0 16 16">
      <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
    </svg>
    <div>
      <strong>{{ questions.length }}</strong> {{ questions.length === 1 ? language.questionremain : language.questionsremain }} {{language.unanswered}}
    </div>
  </div>

  <!-- Questions List -->
  <div class="list-group list-group-flush">
    <button *ngFor="let q of questions; let i = index"
            type="button"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center px-3 py-2"
            (click)="goToQuestion(q.examQuestion.questionno)">
      
      <span>
        <span class="badge bg-secondary me-2">Q{{ q.examQuestion.questionno }}</span>
        <span class="text-truncate">{{language.question}} {{ q.examQuestion.questionno }}</span>
      </span>
    </button>
  </div>
</div>

<div class="modal-footer bg-light border-top">
  <button type="button" class="btn btn-secondary" (click)="closeModal()">
    {{language.close}}
  </button>
</div>